import axios from "axios";


var Registration = {
  initializeHeaders: function (headers) {
    axios.defaults.headers.common = headers;
  },
  getFields: function () {
    return axios.get(
      Apollo.resolveApiUrl("~/register/fields"));
  }
};

export default Registration;



// WEBPACK FOOTER //
// ./src/models/Registration.js